export function formatDispositioned(value) {
  if (value === true || value === 'true') return 'true';
  return 'false';
}
